<template>
  <div class="live">
    <div class="mainWidth">
      <div class="main_box">
        <mu-row gutter class="main_tags">
            <mu-col class="tags_detail_box" width="100" tablet="100" desktop="100">
              <div class="tags_title_box">
                <div class="tags_intro_title">{{$t('service.live.title')}}</div>
                <div class="tags_intro_subtitile">{{$t('service.live.subtitle')}}</div>
              </div>
              <div class="tags_line"></div>
              <mu-row gutter class="tags_detail">
                <mu-col  width="100" tablet="70" desktop="70">
                  <div class="content">
                    <span>{{$t('service.live.intro[0]')}}</span>
                  </div>
                </mu-col>
                <mu-col  width="100" tablet="30" desktop="30">
                  <mu-row gutter>
                    <mu-col class="descript_box" width="33" tablet="30" desktop="30" v-for="item in $t('service.live.tags')" :key="item.title">
                      <img :src="item.icon" alt="">
                      <div class="descript">{{item.title}}</div>
                    </mu-col>
                  </mu-row>


                </mu-col>
              </mu-row>

            </mu-col>
        </mu-row>
      </div>
    </div>
    <div class="mainWidth">
      <div class="merits_box">
        <mu-row gutter class="main_merits">
          <mu-col class="" width="100" tablet="33" desktop="33"  v-for="item in $t('service.live.merits')" :key="item">
            <div class="merits">
              <span class="merits_icon"></span><span class="merits_item">{{item}}</span>
            </div>
          </mu-col>

        </mu-row>
        <div class="main_imgs">
          <div class="imgs_box" v-for="item in $t('service.live.introImgs')">
            <img :src="item.imgs" alt="">
            <div class="description">
              {{item.description}}
            </div>
          </div>
        </div>
      </div>
    </div>


  </div>
</template>

<script>
  export default {
    name: 'erange',
    data () {
      return {
        activeTab:'0',
      }
    },
    created(){

    },
    methods:{
      changeTab(idx){  //tab切换
        this.activeTab=idx;
      },
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less">
  .live{
    overflow:hidden;
    background-color:#E6E6E6;
    padding-bottom:60px;
    .main_box{
      background:#fff;
      overflow:hidden;
      margin-top:17px;
      height:300px;
      padding:27px 60px;
      background:url("../../../static/soft-banner.png") no-repeat center center;
      background-size:100% 100%;
      color:#FFF;
      .main_tags{
          width:inherit;

          .tags_detail_box{
            .tags_title_box{
              height:110px;
              border-bottom:3px solid #FFF;
              display:inline-block;
              .tags_intro_title{
                height:40px;
                line-height:40px;
                margin-top:22px;
                font-family: PingFangSC-Regular;
                font-size: 28px;
                color: #FFFFFF;
                letter-spacing:0;
                text-align:left;
                vertical-align:middle;
                width:auto;

              }
              .tags_intro_subtitile{
                opacity: 0.47;
                font-family: PingFangSC-Regular;
                font-size: 12px;
                color: #FFFFFF;
                letter-spacing: 0;

              }
            }
            .tags_detail{
              width:inherit;
              font-family: PingFangSC-Regular;
              font-size: 16px;
              color: #FFFFFF;
              letter-spacing: 0;
              line-height: 33px;
              padding:40px 0px;
              margin-top:-3px;
              .content{
                padding-right:120px;
              }
              .descript_box{
                text-align:center;
                >img{
                  width:46px;
                  height:46px;
                  margin:0 auto;
                }
                .descirpt{
                  font-size:14px;
                  color: #FFFFFF;
                  letter-spacing: 0;
                  line-height: 22px;
                  text-align:center;
                }
              }
            }
            .tags_line{
              width:inherit;
              height:3px;
              opacity: 0.51;
              background:#E8E8E8;
              margin-top:-3px;
            }
            .tags{
              span{
                font-family: PingFangSC-Semibold;
                font-size: 14px;
                color: #FF6363;
                letter-spacing: 0;
                line-height: 22px;
                padding:0px 8px;
                font-weight:600;
              }
              .tags_icon{
                width:16px;
                height:13px;
                display:inline-block;
                margin-right:8px;
                img{
                  width:inherit;
                  height:inherit;
                }
              }
            }


          }

      }

    }
    .merits_box{
      overflow:hidden;
      background:#fff;
      padding:0px 67px 0px 67px;
      .merit_list{
        width:100%;
        height:auto;
        overflow:hidden;
        .icon{
          width:82px;
          height:82px;
          margin:0 auto;
          >img{
            width:inherit;
            height:inherit;
          }
        }
        .title{
          text-align:center;
          font-family: PingFangSC-Regular;
          font-size: 16px;
          color: #333333;
          letter-spacing: 0;
          line-height:60px;
          border-bottom:1px solid #E8E8E8;
        }
      }
      .main_merits{
        margin:60px 0px;
        .merits{
          .merits_icon{
            display: inline-block;
            width:13px;
            height:13px;
            background: url("../../../static/star-1.png") no-repeat center center;
            background-size: 100% 100%;
            margin-right:8px;
            vertical-align: middle;
          }
          .merits_item{
            display:inline-block;
            font-family: PingFangSC-Medium;
            font-size: 14px;
            color:#3B3B3B;
            letter-spacing: 0;
            line-height: 16px;
            font-weight: 600;
            vertical-align: middle;
          }
        }
      }
      .main_imgs{
        margin:0px 102px;

        .imgs_box{
          width:80%;
          margin:0 auto;
          >img{
            width:100%;
            height:auto;
            margin:60px 0px;
            text-align:center;
            display:inline-block;
          }
          .description{
            font-family: PingFangSC-Medium;
            font-size: 24px;
            line-height:30px;
            color:#3B3B3B;
            letter-spacing: 0;
            width:75%;
            margin:0 auto;
            text-align:center;
          }
        }
      }
    }
  }

</style>




// WEBPACK FOOTER //
// src/page/childrens/live.vue